// Centralized path builders so we don't typo collection names everywhere.
export const gymPath = (gymId) => `gyms/${gymId}`;
export const membersCol = (gymId) => `gyms/${gymId}/members`;
export const memberDoc = (gymId, uid) => `gyms/${gymId}/members/${uid}`;
export const staffCol = (gymId) => `gyms/${gymId}/staff`;
export const staffDoc = (gymId, uid) => `gyms/${gymId}/staff/${uid}`;
export const programsCol = (gymId) => `gyms/${gymId}/programs`;
export const programDoc = (gymId, programId) => `gyms/${gymId}/programs/${programId}`;
export const sessionsCol = (gymId) => `gyms/${gymId}/sessions`;
export const sessionDoc = (gymId, sid) => `gyms/${gymId}/sessions/${sid}`;
export const measurementsCol = (gymId) => `gyms/${gymId}/measurements`;
export const rewardsCol = (gymId) => `gyms/${gymId}/rewards`;
export const redemptionsCol = (gymId) => `gyms/${gymId}/redemptions`;
export const exerciseOverridesDoc = (gymId, eid) => `gyms/${gymId}/exerciseOverrides/${eid}`;
export const exercisesCol = () => `exercises`;
export const customExercisesCol = (gymId) => `gyms/${gymId}/customExercises`;
export const customExerciseDoc = (gymId, id) => `gyms/${gymId}/customExercises/${id}`;
export const glassesDevicesCol = (gymId) => `gyms/${gymId}/glassesDevices`;
export const waiversCol = (gymId) => `gyms/${gymId}/waivers`;
export const waiverDoc = (gymId, id) => `gyms/${gymId}/waivers/${id}`;
export const auditLogCol = (gymId) => `gyms/${gymId}/auditLog`;
export const leaderboardDoc = (gymId) => `gyms/${gymId}/leaderboards/current`;
export const progressPhotosCol = (gymId) => `gyms/${gymId}/progressPhotos`;
export const templatesCol = (gymId) => `gyms/${gymId}/templates`;
export const conversationsCol = (gymId) => `gyms/${gymId}/conversations`;
export const messagesSubcol = (gymId, convoId) => `gyms/${gymId}/conversations/${convoId}/messages`;
export const eventsCol = (gymId) => `gyms/${gymId}/events`;
export const analyticsCol = (gymId) => `gyms/${gymId}/analytics`;
export const aiFeedbackCol = (gymId) => `gyms/${gymId}/aiFeedback`;
export const feedbackCol = (gymId) => `gyms/${gymId}/feedback`;
export const gymProfilesCol = () => 'gymProfiles';
export const gymProfileDoc = (profileId) => `gymProfiles/${profileId}`;
export const gymProfileExercisesCol = (profileId) => `gymProfiles/${profileId}/exercises`;
export const gymProfileExerciseDoc = (profileId, id) => `gymProfiles/${profileId}/exercises/${id}`;
